import { Component, Input } from '@angular/core';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLabel } from '@angular/material/input';

@Component({
  selector: 'app-eight-by-eight-settings',
  imports: [FormsModule, MatLabel, ReactiveFormsModule],
  templateUrl: './eight-by-eight-settings.component.html',
  styleUrl: '../call-integration-settings.scss',
})
export class EightByEightSettingsComponent {
  @Input()
  form: FormGroup;

  @Input()
  isApiKeySet: boolean;

  @Input()
  isApiSecretSet: boolean;
}
